export default "__VITE_ASSET__B3a00Yns__"